export default "__VITE_ASSET__2_gikH$7__"